var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cts_box"},[_vm._m(0),_c('router-link',{staticClass:"link_txt",attrs:{"to":"/admin"}},[_vm._v("サイト管理へ")])],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('h2',{staticClass:"min_ttl"},[_c('span',[_vm._v("サイト管理（※スタッフ専用）")])])
}]

export { render, staticRenderFns }